import axios from 'axios';
const API = axios.create({baseURL:'https://mongoapi-beryl.vercel.app/'});
API.interceptors.request.use((req) => {
    if (localStorage.getItem('profile')) {
      req.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem('profile')).token}`;
    }
    return req;
  });
 export const signIn=(formData)=> API.post('/user/signin',formData);


